export const CHECKOUT_PREPARATION_TIMEOUT_MS = 90_000;
export const CHECKOUT_RECOVERY_POLL_MS = 2_000;

const normalizeText = (value) => String(value || '').trim();

export function checkoutPreparationStage(seconds) {
  const elapsed = Math.max(0, Number(seconds) || 0);
  if (elapsed < 3) return 'request';
  if (elapsed < 16) return 'provider';
  if (elapsed < 36) return 'contract';
  if (elapsed < 61) return 'stripe';
  return 'extended';
}

export function openCheckoutPreparationWindow(browserWindow = window) {
  const popup = browserWindow.open('', 'yga-stripe-checkout');
  if (!popup) return null;
  try {
    popup.opener = null;
    popup.document.title = 'Stripe-Checkout wird vorbereitet';
    popup.document.body.textContent = 'Der sichere Stripe-Checkout wird vorbereitet. Dieses Fenster bleibt automatisch geöffnet.';
    popup.document.body.setAttribute('style', 'font: 16px system-ui; max-width: 42rem; margin: 4rem auto; padding: 1.5rem; line-height: 1.5;');
  } catch {}
  return popup;
}

export function openPreparedCheckout(popup, checkoutUrl, browserWindow = window) {
  const parsed = new URL(checkoutUrl);
  if (parsed.protocol !== 'https:' || parsed.hostname !== 'checkout.stripe.com') {
    throw new Error('Unsichere Stripe-Checkout-Adresse.');
  }
  if (popup && !popup.closed) {
    popup.location.replace(parsed.toString());
    popup.focus?.();
    return 'popup';
  }
  browserWindow.location.assign(parsed.toString());
  return 'current';
}

export function closeCheckoutPreparationWindow(popup) {
  try {
    if (popup && !popup.closed) popup.close();
  } catch {}
}

export function matchesRecoverableChange(change, {
  subscriptionId,
  changeType,
  targetPlanCode,
  startedAt,
}) {
  if (!change || change.status !== 'payment_method_pending') return false;
  if (normalizeText(change.source_subscription_id) !== normalizeText(subscriptionId)) return false;
  if (change.change_type !== changeType) return false;
  if (targetPlanCode && normalizeText(change.target_plan_code).toLowerCase() !== normalizeText(targetPlanCode).toLowerCase()) return false;
  const createdAt = Date.parse(change.created_at || '');
  return Number.isFinite(createdAt) && createdAt >= startedAt - 5_000;
}
